import React from 'react';
import PropTypes from 'prop-types';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import reducer from './reducers';
import Summary from './components/Summary';
import SummaryTrials from './components/SummaryTrials';
import Form from './components/Form';
import Terms from './components/Terms';
import styles from './index.scss';

class Checkout extends React.Component {
  store = createStore(reducer, this.props, applyMiddleware(thunk));

  renderSummary = () => {
    const { isTrial } = this.props;

    if (isTrial) {
      return <SummaryTrials />;
    }

    return <Summary />;
  };

  render() {
    return (
      <Provider store={this.store}>
        <>
          <div className={styles.container}>
            {this.renderSummary()}
            <Form />
          </div>
          <Terms />
        </>
      </Provider>
    );
  }
}

Checkout.defaultProps = {
  isTrial: false
};

Checkout.propTypes = {
  isTrial: PropTypes.bool
};

export default Checkout;
